package com.solevo.dist.components


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Created by Ilija Vucetic on 6.10.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
@Composable
fun CenteredLoader(
    modifier: Modifier = Modifier,
    message: String = "Loading…"
) {
    Box(modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        SpanText(message)
    }
}